import {
    SAFlag,
    USFlag,
    INFlag,
    AEDFlag,
    EURFlag,
    GBPFlag,
    BHDFlag,
    KWDFlag,
    QARFlag,
    OMRFlag,
    EGFlag
} from '@assets/svgs/flags'

export const flagMap: Record<string, React.ComponentType<any>> = {
    SAR: SAFlag,
    USD: USFlag,
    INR: INFlag,
    EUR: EURFlag,
    AED: AEDFlag,
    BHD: BHDFlag,
    GBP: GBPFlag,
    KWD: KWDFlag,
    QAR: QARFlag,
    OMR: OMRFlag,
    EGP: EGFlag
}
